/** What can happen to a contact and trigger a workflow (Admins `workflows.<id>.events`). */
export enum WorkflowEvent {
  tagAdded = "tag_added",
  call = "call",
  voicemail = "voicemail",
  smsReceived = "sms_received",
  whatsapp = "whatsapp",
  noteAdded = "note_added",
  contactUpdated = "contact_updated",
}

export const WorkflowEventLabel: Record<WorkflowEvent, string> = {
  [WorkflowEvent.tagAdded]: "Tag ajouté",
  [WorkflowEvent.call]: "Appel",
  [WorkflowEvent.voicemail]: "Message vocal",
  [WorkflowEvent.smsReceived]: "SMS reçu",
  [WorkflowEvent.whatsapp]: "WhatsApp reçu",
  [WorkflowEvent.noteAdded]: "Note",
  [WorkflowEvent.contactUpdated]: "Fiche contact modifiée",
}
